import router from "../../router";
import { indexTitle } from '@/config/defaultSysUrls';

export default {
  state:{
    dialogFormVisible:false,
    title:"",
    moduleid:'',
    data:{},
    trainingNavStatus: "0",//培训平台的路由跳转
    courseMenuStatus : '', // 学习端，左侧菜单栏选中状态
    CourseSystemRetract: true,//课程编辑收缩
    hlepIndex:"0",//首页帮助中心跳转下标
    dataPresentationPitchOn:'广东省',//图表图
    pitchOnRegionCityCode:''//图表图
  },
  mutations:{
      switch_dialog(state){//这里的state对应着上面这个state
          state.dialogFormVisible = state.dialogFormVisible?false:true;
      },
      setTrainingNavStatus(state,value){
        if (value == 6){
          document.title = indexTitle + '-数据统计'
        } else {
          document.title = indexTitle
        }
        state.trainingNavStatus=value
      },
      setCourseMenuStatus(state, val){
        state.courseMenuStatus = val
      },
      setHlepIndex(state,value){
        state.hlepIndex=value
      },
      setDataPresentationPitchOn(state,value){
        state.dataPresentationPitchOn=value
      },
      CourseSystemRetractSwich(state){
        state.CourseSystemRetract=!state.CourseSystemRetract        
        console.log(!state.CourseSystemRetract)
      },
      setPitchOnRegionCityCode(state,value){
        state.pitchOnRegionCityCode = value
      }
  },
  getters: {
      dialog_info:(state) => (list) =>{
        state.title = list.title;
        state.moduleid = list.moduleid;
        state.data = list.data;
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/orgaCommon.js